import { PromoHistoryResponse } from '@/api';
import { PromoHistoryData, PromoCodeItemData } from '../models';

const promoHistory = (response: PromoHistoryResponse): PromoHistoryData => {
  const { data } = response;

  return <PromoHistoryData>{
    result: data.result,
    pageLimit: data.pageLimit,
    totalCount: parseInt(data.totalCount, 10),
    balance: data.balance,
    amlFlow: data.amlFlow,
    discount: data.discount,
    discountDueTime: data.discountDueTime,
    promoFlow: data.promoFlow,
    items: data.data.map((item) => {
      return <PromoCodeItemData>{
        name: item.name,
        create: item.create,
        value: item.value,
        status: item.status,
      };
    }),
  };
};

export { promoHistory };
